import React, { useMemo } from "react";
// import { useNavigate } from "react-router-dom";
import BillCreationForm from "./BillCreation";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import {
  Grid,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  Typography,
  Box,
  Button,
} from "@mui/material";
import PrintIcon from "@mui/icons-material/Print";
import EditIcon from "@mui/icons-material/Edit";
import IconButton from "@mui/material/IconButton";
import InfiniteScroll from "react-infinite-scroll-component";
import { useEffect, useState } from "react";
import Tooltip from "@mui/material/Tooltip";
import {
  billList,
  billSettlement,
  getFreightsByBilPartyIdApi,
  billUpdate,
  billDelete,
} from "../../../Services/Services";
import Popover from "@mui/material/Popover";
import DeleteIcon from "@mui/icons-material/Delete";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import * as XLSX from "xlsx-js-style";
import { saveAs } from "file-saver";

const BillSummaryTable = () => {
  const [openEditModal, setOpenEditModal] = React.useState(false);
  const [selectedRow, setSelectedRow] = React.useState(null);
  const [billData, setBillData] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorEl1, setAnchorEl1] = useState(null);
  const [settelement, setSetelement] = useState(null);
  const [deleteRow, setdeleteRow] = useState(null);
  const [freightOptions, setFreightOptions] = useState([]);
  const [filterfreight_data, setFilterfreight_data] = useState([]);
  const [totalNetPayable, setTotalNetPayable] = useState(0);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({
    branch: "",
    billId: "",
    freightId: "",
    party: "",
  });

  useEffect(() => {
    fetchFilteredBills(1, filters);
  }, []);

  const fetchFilteredBills = async (pageNo = 1, appliedFilters = filters) => {
    if (loading) return;
    setLoading(true);

    const res = await billList(pageNo, appliedFilters);

    const bills = Array.isArray(res.results) ? res.results : [];

    if (pageNo === 1) {
      setBillData(bills);
    } else {
      setBillData((prev) => [...prev, ...bills]);
    }

    setHasMore(!!res.next);
    setPage(pageNo + 1);
    setLoading(false);
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchFilteredBills(1);
    }, 500);
    return () => clearTimeout(handler);
  }, [filters]);

  const fetchMoreData = () => {
    if (!loading && hasMore) {
      fetchFilteredBills(page);
    }
  };

  const handleEditClick = async (row) => {
    const response = await getFreightsByBilPartyIdApi(row.party_id);
    const mergedArray = row.freights.concat(response || []);

    setFreightOptions(mergedArray);
    setSelectedRow(row);
    setTotalNetPayable(row.total_amount || 0);
    setOpenEditModal(true);
  };

  const handleComplete = async (id) => {
    const data = await billSettlement(id);
    setBillData(data.results);
  };

  const handleDelete = async (bill_id) => {
    try {
      const response = await billDelete(bill_id);
      setBillData(response);
    } catch (error) {
      console.error("Error fetching branch:", error);
    }
  };

  const handleFilterChange = (key, value) => {
    setFilters((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const filteredData = useMemo(() => {
    return billData.filter((row) => {
      const matchBranch = filters.branch
        ? row.branch_name?.toLowerCase().includes(filters.branch.toLowerCase())
        : true;
      const matchBillingId = filters.billId
        ? row.billing_id?.toString().includes(filters.billId.trim())
        : true;
      const matchFreightId = filters.freightId
        ? row.freights?.some((freight) =>
          freight.freight_id?.toString().includes(filters.freightId.trim())
        )
        : true;
      const matchParty = filters.party
        ? row.party_name?.toLowerCase().includes(filters.party.toLowerCase())
        : true;

      return matchBranch && matchBillingId && matchFreightId && matchParty;
    });
  }, [filters, billData]);

  // Calculate totals for the filtered data
  const calculateTotals = () => {
    let totalAmt = 0;
    let paidAmt = 0;
    let hisabAmt = 0;
    let balAmt = 0;

    filteredData.forEach((row) => {
      totalAmt += parseFloat(row.total_amount || 0);
      paidAmt += parseFloat(row.paid_amount || 0);
      hisabAmt += parseFloat(row.hisab_amt || 0);
      balAmt += parseFloat(row.total_amount || 0) - parseFloat(row.hisab_amt || 0);
    });

    return {
      totalAmt: totalAmt.toFixed(2),
      paidAmt: paidAmt.toFixed(2),
      hisabAmt: hisabAmt.toFixed(2),
      balAmt: balAmt.toFixed(2)
    };
  };

  function formatOnlyDate(dateTimeString, format = "dd-mm-yyyy") {
    const date = new Date(dateTimeString);

    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();

    if (format === "dd-mm-yyyy") {
      return `${day}-${month}-${year}`;
    } else if (format === "yyyy-mm-dd") {
      return `${year}-${month}-${day}`;
    } else {
      throw new Error("Unsupported format. Use 'dd-mm-yyyy' or 'yyyy-mm-dd'.");
    }
  }

  const handleSubmit = async () => {
    const freightData = freightOptions.map((row) => ({
      freight_id: row.freight_id,
      is_bill: row.is_bill,
    }));

    const billedIds = freightData
      .filter((row) => row.is_bill)
      .map((row) => row.freight_id);

    const Filterfreight_data = freightData.filter(
      (row) => row.is_bill === true
    );
    setFilterfreight_data(Filterfreight_data);

    const data = {
      billing_id: selectedRow.billing_id,
      freight_id: billedIds,
      freight_data: freightData,
      total_amount: totalNetPayable,
      rem_amount: Number(totalNetPayable) - Number(selectedRow.paid_amount),
    };

    const response = await billUpdate(selectedRow.billing_id, data);
    if (response) {
      setBillData(response);
      setOpenEditModal(false);
      setFreightOptions([]);
      setSelectedRow(null);
      setTotalNetPayable(0);
    }
  };

  const handleIsBillToggle = (freightId) => {
    setFreightOptions((prevOptions) => {
      const updatedOptions = prevOptions.map((row) => {
        if (row.freight_id === freightId) {
          return { ...row, is_bill: !row.is_bill };
        }
        return row;
      });

      const newTotal = updatedOptions.reduce((sum, row) => {
        return row.is_bill ? sum + (parseFloat(row.net_amount) || 0) : sum;
      }, 0);

      setTotalNetPayable(newTotal);
      return updatedOptions;
    });
  };

  const getInitials = (str) => {
    return str
      .split(" ")
      .filter((word) => word)
      .map((word) => word[0])
      .join("")
      .toUpperCase();
  };

  const handlePrintClicksiltara = (row) => {
    const freightRows =
      row.freights
        ?.map(
          (item, index) => `
    <tr>
      <td>${index + 1}</td>
          <td>${formatOnlyDate(item.loading_date) || ""}</td>
      <td>${item.truck_no || ""}</td>
           <td>${item.do_no || ""}</td>
      <td>${item.loading_wt || ""}</td>
      <td>${item.received_wt || ""}</td>
      <td>${item.shortage_wt || 0}</td>
      <td>${item.freight_rate || ""}</td>
      <td>${item.total_advance || ""}</td>
    
      <td></td>
    </tr>
  `
        )
        .join("") || "";
    const printWindow = window.open("", "", "height=600,width=1000");
    printWindow.document.write(`
<html>
<head>
    <title> ${row.branch_name === "RAIPUR"
        ? "SRE"
        : row.branch_name === "BILASPUR"
          ? "JHT"
          : "MBR"
      }/${row.billing_id}/${getInitials(row.party_name)}</title>
    <style>
        body {
            font-family: Arial, sans-serif;
            margin: 20px;
        }
        .header {
            text-align: center;
            border-bottom: 1px solid black;
            padding-bottom: 10px;
        }
        .header-top {
            display: flex;
            justify-content: space-between;
            font-size: 14px;
        }
        .title-container {
            background-color: black;
            width: 100%;
            padding: 5px 0;
        }
        .title {
            font-weight: bold;
            font-size: 36px;
            color: white;
        }
        .subtitle {
            font-weight: bold;
            margin: 2px 0;
        }
        .ref-date {
            display: flex;
            justify-content: space-between;
            margin: 5px 0 5px 0;
        }
        .recipient {
            text-align: start;
            margin-bottom: 20px;
        }
        .account {
            text-align: center;
            font-weight: bold;
            margin-bottom: 10px;
            line-height: 0.5;
        }
         table {
        width: 100%;
        border-collapse: collapse;
        table-layout: auto;
        font-size: 13px;
        line-height: 1.3;
        border: 1px solid black;
    }

    th, td {
        border: 1px solid black;
        text-align: center;
        font-weight: normal;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    th {
        background-color: #f0f0f0;
        font-weight: bold;
    }

    </style>
</head>
<body>

    <div class="header">
        <div class="header-top">
            <div>Pan No - BKDPD9609Q</div>
            <div>Mo. No - 8727048717</div>
        </div>
        <div class="title-container">
            <div class="title">MAA BANJARI ROADWAYS</div>
        </div>
        <div class="subtitle">SILTARA, RAIPUR (C.G.)</div>
    </div>

    <div class="ref-date">
        <div>Ref. No. :  ${row.branch_name === "RAIPUR"
        ? "SRE"
        : row.branch_name === "BILASPUR"
          ? "JHT"
          : "MBR"
      }/${row.billing_id}/${getInitials(row.party_name)}</div>
        <div>Date :  ${formatOnlyDate(row.created_at)}</div>
    </div>

    <div class="account">
        <p>ACCOUNT DETAILS</p>
        <p>NAME : MAA BANJARI ROADWAYS</p>
        <p>A/C NO : 1216102000004497</p>
        <p>IFSC CODE : IBKL0001216</p>
    </div>

    <div class="recipient">
        <p>TO,<br>${row.party_name}<br>${row.address}</p>
    </div>

    <table>
        <tr>
        <th>Sr. No</th>
           <th>Date</th>
        <th>Truck No.</th>
        <th>Do No</th>
        <th>Load Wt</th>
        <th>Rec Wt</th>
        <th>Short Wt</th>
        <th>Rate</th>
        <th>Total Adv.</th>
        
        <th>Remark</th>
      </tr>
        ${freightRows}
    </table>
     <footer style="position: fixed; bottom: 0; left: 0; width: 100%; text-align: center; font-size: 12px; color: #555;">
      Powered by : YASHVITECH IT SOLUTION PVT. LTD. , 8223079476
    </footer>
     <script>
    window.onload = function() {
      window.print();
      window.onafterprint = function() {
        window.close();
      };
    };
  </script>

</body>
</html>


    `);

    printWindow.document.close();
  };


  const handlePrintClickAshutosh = (row) => {
    const freightRows =
      row.freights
        ?.map(
          (item, index) => `
    <tr>
      <td>${index + 1}</td>
          <td>${formatOnlyDate(item.loading_date) || ""}</td>
      <td>${item.truck_no || ""}</td>
           <td>${item.do_no || ""}</td>
      <td>${item.loading_wt || ""}</td>
      <td>${item.received_wt || ""}</td>
      <td>${item.shortage_wt || 0}</td>
      <td>${item.freight_rate || ""}</td>
      <td>${item.total_advance || ""}</td>
    
      <td></td>
    </tr>
  `
        )
        .join("") || "";
    const printWindow = window.open("", "", "height=600,width=1000");
    printWindow.document.write(`
<html>
<head>
    <title>AKS/${row.billing_id}/${getInitials(row.party_name)}</title>
    <style>
        body {
            font-family: Arial, sans-serif;
            margin: 20px;
        }
        .header {
            text-align: center;
            border-bottom: 1px solid black;
            padding-bottom: 10px;
        }
        .header-top {
            display: flex;
            justify-content: space-between;
            font-size: 14px;
        }
        .title-container {
            background-color: black;
            width: 100%;
            padding: 5px 0;
        }
        .title {
            font-weight: bold;
            font-size: 36px;
            color: white;
        }
        .subtitle {
            font-weight: bold;
            margin: 2px 0;
        }
        .ref-date {
            display: flex;
            justify-content: space-between;
            margin: 5px 0 5px 0;
        }
        .recipient {
            text-align: start;
            margin-bottom: 20px;
        }
        .account {
            text-align: center;
            font-weight: bold;
            margin-bottom: 10px;
            line-height: 0.5;
        }
         table {
        width: 100%;
        border-collapse: collapse;
        table-layout: auto;
        font-size: 13px;
        line-height: 1.3;
        border: 1px solid black;
    }

    th, td {
        border: 1px solid black;
        text-align: center;
        font-weight: normal;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    th {
        background-color: #f0f0f0;
        font-weight: bold;
    }

    </style>
</head>
<body>

    <div class="header">
        <div class="header-top">
            <div>Pan No - LZQPS9703J</div>
            <div>Mo. No - 8602856129</div>
        </div>
        <div class="title-container">
            <div class="title">ASHUTOSH KUMAR SINGH</div>
        </div>
        <div class="subtitle">TRANSPORT NAGAR, RAIPUR (C.G.)493221</div>
    </div>

    <div class="ref-date">
      <div>Ref. No. : AKS/${row.billing_id}/${getInitials(row.party_name)}</div>
        <div>Date :  ${formatOnlyDate(row.created_at)}</div>
    </div>

    <div class="account">
        <p>ACCOUNT DETAILS</p>
        <p>NAME : ASHUTOSH KUMAR SINGH</p>
        <p>A/C NO : 1216102000009911</p>
        <p>IFSC CODE : IBKL0001216</p>
    </div>

    <div class="recipient">
        <p>TO,<br>${row.party_name}<br>${row.address}</p>
    </div>

    <table>
        <tr>
        <th>Sr. No</th>
           <th>Date</th>
        <th>Truck No.</th>
        <th>Do No</th>
        <th>Load Wt</th>
        <th>Rec Wt</th>
        <th>Short Wt</th>
        <th>Rate</th>
        <th>Total Adv.</th>
        
        <th>Remark</th>
      </tr>
        ${freightRows}
    </table>
     <footer style="position: fixed; bottom: 0; left: 0; width: 100%; text-align: center; font-size: 12px; color: #555;">
      Powered by : YASHVITECH IT SOLUTION PVT. LTD. , 8223079476
    </footer>
     <script>
    window.onload = function() {
      window.print();
      window.onafterprint = function() {
        window.close();
      };
    };
  </script>

</body>
</html>


    `);

    printWindow.document.close();
  };

  const handlePrintClickBilaspur = (row) => {
    const freightRows =
      row.freights
        ?.map(
          (item, index) => `
    <tr>
      <td>${index + 1}</td>
          <td>${formatOnlyDate(item.loading_date) || ""}</td>
      <td>${item.truck_no || ""}</td>
           <td>${item.do_no || ""}</td>
      <td>${item.loading_wt || ""}</td>
      <td>${item.received_wt || ""}</td>
      <td>${item.shortage_wt || 0}</td>
      <td>${item.freight_rate || ""}</td>
      <td>${item.total_advance || ""}</td>
    
      <td></td>
    </tr>
  `
        )
        .join("") || "";
    const printWindow = window.open("", "", "height=600,width=1000");
    printWindow.document.write(`
     <html>
<head>
  <title>
    ${row.branch_name === "RAIPUR"
        ? "SRE"
        : row.branch_name === "BILASPUR"
          ? "JHT"
          : "MBR"
      }${row.billing_id}${getInitials(row.party_name)}
    </title>
  <style>
    body {
      font-family: Arial, sans-serif;
      padding: 20px;
      background-color: #fff;
      background-image: url(https://vehiclemanagement.s3.ap-south-1.amazonaws.com/sr/bg.jpg);
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
    }
    .center {
      text-align: center;
    }
    .title {
      font-size: 32px;
      font-weight: bold;
      color: #fff;
      border: 2px solid white;
      display: inline-block;
      padding: 8px 16px;
      border-radius: 6px;
      margin-bottom: 5px;
    }
    .subtitle {
      font-size: 13px;
      color: #fff;
    }
    .info-table {
      width: 100%;
      border-collapse: collapse;
      margin-top: 20px;
      font-size: 12px;
    }
    .info-table td {
      border: 1px solid black;
      padding: 4px;
      vertical-align: top;
    }
    th{
         background-color: rgba(211, 211, 211, 0.42);
            color: #000;
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
        }
    .small-table {
      width: 100%;
      border-collapse: collapse;
      margin-top: 20px;
      font-size: 12px;
    }
    .small-table th, .small-table td {
      border: 1px solid black;
      padding: 4px;
      text-align: center;
    }
    .small-table thead {
      background-color: #f0f0f0;
      font-weight: bold;
    }
    #footer-print {
      position: fixed;
            bottom: 25px;
            width: 100%;
            text-align: center;
    }
    #hrtag {
      position: fixed;
            bottom: 0px;
            width: 100%;
    }
               .account-info {
  page-break-inside: avoid;
  break-inside: avoid;
  padding: 10px;
  font-size: 16px;
  text-align: start;
  margin-top: 20px;
  border-top: 1px dashed #ccc;
}

    .contact {
      display: flex;
      justify-content: center;
      gap: 20px;
      align-items: center;
      flex-wrap: wrap;
      margin-top: 8px;
      font-size: 14px;
    }
    .contact-item {
      display: flex;
      align-items: center;
      gap: 6px;
    }
    .icon {
      font-size: 16px;
      color: #d4af37;
    }
    .whatsapp-icon {
      color: #25D366;
    }
      footer {
            position: fixed;
            bottom: 0px;
            width: 100%;
            text-align: center;
            font-size: 12px;
            color: #333;
          }
    .account-info h3{
    font-size: 18px;
      margin-bottom: 10px;
    }
      .account-info p{
    font-size: 18px;
      margin-bottom: 10px;
      font-weight: bold;
      font-size: 16px;
    }
    .account-info{
     line-height: 0.4;
    }
    
  </style>
</head>
<body>

  <div class="center">
    <div class="title">JAI HANUMAN TRANSPORT</div>
  
  </div>

  <div style="font-size: 14px; color: #fff; margin-top: 5px; display: flex; justify-content: space-between; padding: 0 40px;">
  <div style="text-align: left;">
    <div>Transport Nagar, Raipur (C.G.)</div>
    <div>Contact: 9685190720</div>
    <div>PAN: BJVPS6722C</div>
    <div style="margin-top: 5px;" >Ref No: ${row.branch_name === "RAIPUR"
        ? "SRE"
        : row.branch_name === "BILASPUR"
          ? "JHT"
          : "MBR"
      }/${row.billing_id}/${getInitials(row.party_name)}</div>
  </div>
  <div style="text-align: right;">
    <div>Date: ${formatOnlyDate(row.created_at)}</div>
  </div>
  </div>
<div style="line-height: 1; margin-top: 20px; padding: 10px;">
  <p style="margin: 0;"><strong>To:</strong></p>
  <p style="margin: 0;"><strong>${row.party_name}</strong></p>
  <p style="margin: 0;">${row.address}</p>
</div>

  <table class="small-table">
    <thead>
      <tr>
        <th>Sr. No</th>
           <th>Date</th>
        <th>Truck No.</th>
        <th>Do No</th>
        <th>Load Wt</th>
        <th>Rec Wt</th>
        <th>Short Wt</th>
        <th>Rate</th>
        <th>Total Adv.</th>
        
        <th>Remark</th>
      </tr>
    </thead>
    <tbody>
   ${freightRows}
    </tbody>
  </table>
 <div class="account-info">
      <h3><b>Account Details :-</b></h3>
      <p><b>NAME : JAI HANUMAN TRANSPORT</b></p>
      <p><b>A/C NO : 181705500997</b></p>
      <p><b>IFSC CODE : ICIC0001817</b></p>
      <p><b>BANK : ICICI BANK (RAIPUR)</b></p>
 
           </div>
        
  
  <hr style="border: none; border-top: 1px solid #aaa; margin: 20px 0;" id="hrtag" />
<footer>Powered by : YASHVITECH IT SOLUTION PVT. LTD. , 8223079476</footer>
  <script>
    window.onload = function() {
      window.print();
      window.onafterprint = function() {
        window.close();
      };
    };
  </script>

</body>
</html>

    `);

    printWindow.document.close();
  };

  const handlePrintClickRaipur = (row) => {
    const firstPageLimit = 25;
    const otherPagesLimit = 35;
    const freights = row.freights;

    const chunkedRows = [];
    let i = 0;

    if (freights.length > 0) {
      chunkedRows.push(freights.slice(0, firstPageLimit));
      i = firstPageLimit;
    }

    while (i < freights.length) {
      chunkedRows.push(freights.slice(i, i + otherPagesLimit));
      i += otherPagesLimit;
    }

    const generateTablePages = () =>
      chunkedRows
        .map((chunk, pageIndex) => {
          const rows = chunk
            .map(
              (item, index) => `
            <tr>
              <td>${pageIndex === 0
                  ? index + 1
                  : firstPageLimit +
                  (pageIndex - 1) * otherPagesLimit +
                  index +
                  1
                }</td>
              <td>${formatOnlyDate(item.loading_date) || ""}</td>
              <td>${item.truck_no || ""}</td>
              <td>${item.do_no || ""}</td>
              <td>${item.loading_wt || ""}</td>
              <td>${item.received_wt || ""}</td>
              <td>${item.shortage_wt || 0}</td>
              <td>${item.freight_rate || ""}</td>
              <td>${item.total_advance || ""}</td>
              <td></td>
            </tr>`
            )
            .join("");

          return `
          <div class="page-section">
            ${pageIndex === 0
              ? `
              <div class="top-banner">
                <div class="banner-text">
                  <h1>S. R. ENTERPRISES</h1>
                  <p>Transport Contractor & Commission Agent</p>
                  <p><strong>PAN: LZQPS9703J</strong></p>
                  <p>Ashutosh Ku. Singh</p>
                </div>
              </div>
              <div class="ref-account-row">
                <div class="recipient-info">
                  <p><strong>Ref No:</strong>  ${row.branch_name === "RAIPUR"
                ? "SRE"
                : row.branch_name === "BILASPUR"
                  ? "JHT"
                  : "MBR"
              }/${row.billing_id}/${getInitials(row.party_name)}</p>
                  <p><strong>Date:</strong> ${formatOnlyDate(
                row.created_at
              )}</p>
                  <p><strong>To:</strong></p>
                  <p>${row.party_name}</p>
                  <p>${row.address}</p>
                </div>
                <div class="account-info">
                  <h3>Account Details :-</h3>
                  <p><strong>NAME: S.R. ENTERPRISES</strong></p>
                  <p><strong>A/C NO: 50200079484752</strong></p>
                  <p><strong>IFSC CODE: HDFC0006110</strong></p>
                  <p><strong>BANK: HDFC BANK (RAIPUR)</strong></p>
                </div>
              </div>
            `
              : ""
            }
            <table>
              <thead>
                <tr>
                  <th>Sr. No</th>
                  <th>Date</th>
                  <th>Truck No.</th>
                  <th>Do No</th>
                  <th>Load Wt</th>
                  <th>Rec Wt</th>
                  <th>Short Wt</th>
                  <th>Rate</th>
                  <th>Total Adv.</th>
                  <th>Remark</th>
                </tr>
              </thead>
              <tbody>${rows}</tbody>
            </table>
            ${pageIndex === chunkedRows.length - 1
              ? `
              <div class="footer-fixed">
                <p class="address">Near RTO Office, Transport Nagar, Raipur (C.G.) 493221</p>
                <div class="contact-row">
                  <span><img src="https://vehiclemanagement.s3.ap-south-1.amazonaws.com/sr/telephone.png" /> 8602856129</span>
                  <span><img src="https://vehiclemanagement.s3.ap-south-1.amazonaws.com/sr/phone-call.png" /> 8602856129</span>
                  <span><img src="https://vehiclemanagement.s3.ap-south-1.amazonaws.com/sr/email.png" /> singhashu1555@gmail.com</span>
                </div>
                <div>Powered by YASHVITECH IT SOLUTION PVT. LTD. , 8223079476</div>
              </div>`
              : ""
            }
          </div>`;
        })
        .join("");

    const printWindow = window.open("", "", "height=600,width=1000");
    printWindow.document.write(`
<!DOCTYPE html>
<html>
<head>
  <title> ${row.branch_name === "RAIPUR"
        ? "SRE"
        : row.branch_name === "BILASPUR"
          ? "JHT"
          : "MBR"
      }/${row.billing_id}/${getInitials(row.party_name)}</title>
  <style>
    * { box-sizing: border-box; }
    body { margin: 0; font-family: Arial, sans-serif; }
    .top-banner {
      height: 180px;
      background: url('https://vehiclemanagement.s3.ap-south-1.amazonaws.com/sr/2.png') no-repeat center top;
      background-size: contain;
      position: relative;
    }
    .banner-text {
      position: absolute; top: -20px; left: 98px; color: white;
    }
    .banner-text h1 { font-size: 2.3rem; margin-bottom: 0.2rem; line-height: 1.2; }
    .banner-text p { margin: 0.1rem 0; line-height: 1.2; }
    .ref-account-row { display: flex; justify-content: space-between; margin: 10px 20px; }
    .recipient-info p, .account-info p { margin: 0; font-size: 13px; }
    .account-info h3 { margin: 0 0 4px 0; font-size: 14px; text-decoration: underline; }
    table { width: 100%; border-collapse: collapse; font-size: 13px; margin-top: 10px; }
    th, td { border: 1px solid #000; padding: 4px; text-align: center; }
    thead { background-color: #f3f3f3; display: table-header-group; }
    tr { page-break-inside: avoid; }
    .page-section { position: relative; min-height: 100vh; padding: 20px; box-sizing: border-box; page-break-after: always; }
    .page-section:last-child { page-break-after: auto; }
    .footer-fixed {
      position: absolute;
      bottom: 20px;
      left: 0;
      right: 0;
      padding: 10px 20px;
      text-align: center;
      font-weight: bold;
      color: #333;
      font-size: 13px;
      border-top: 1px solid #ddd;
    }
    .footer-fixed .address { font-size: 13px; }
    .contact-row { display: flex; justify-content: center; gap: 20px; flex-wrap: wrap; margin: 5px 0; }
    .contact-row span { font-size: 13px; display: flex; align-items: center; }
    .contact-row img { width: 16px; height: 16px; margin-right: 5px; }
  </style>
</head>
<body>
  ${generateTablePages()}
  <script>
    window.onload = function () {
      window.print();
      window.onafterprint = function () {
        window.close();
      };
    };
  </script>
</body>
</html>`);
    printWindow.document.close();
  };

  const handleExportExcel = (freightData) => {
    const wsData = [];

    const headers = [
      "Sr. No",
      "Freight ID",
      "Truck No",
      "Party Name",
      "Branch Name",
      "Loading Date",
      "Unloading Date",
      "DO No",
      "TP No",
      "From",
      "To",
      "Loading Wt",
      "Received Wt",
      "Shortage Wt",
      "Billing Wt",
      "Freight Rate",
      "Freight Amt",
      "TDS %",
      "TDS Amt",
      "Shortage Rate",
      "Shortage Amt",
      "Mines Exp",
      "Diesel Exp",
      "Cash Exp",
      "Total Advance",
      "Commission",
      "Net Amount",
      "Other Exp",
      "Net Payable",
      "Paid Amt",
      "Balance Amt",
      "Truck Owner",
      "Phone No",
      "PAN No",
      "Remark",
      "Created Date"
    ];

    wsData.push(headers);

    freightData.forEach((row, index) => {
      wsData.push([
        index + 1,
        row.freight_id || "",
        row.truck_no || "",
        row.party_name || "",
        row.branch_name || "",
        row.loading_date || "",
        row.unloading_date || "",
        row.do_no || "",
        row.tp_no || "",
        row.from_location || "",
        row.to_location || "",
        row.loading_wt || 0,
        row.received_wt || 0,
        row.shortage_wt || 0,
        row.billing_wt || 0,
        row.freight_rate || 0,
        row.freight_amt || 0,
        row.tds_per || 0,
        row.tds_amt || 0,
        row.shortage_rate || 0,
        row.shortage_amt || 0,
        row.ad_mines_exp || 0,
        row.ad_diesel_exp || 0,
        row.ad_cash_exp || 0,
        row.total_advance || 0,
        row.commission || 0,
        row.net_amount || 0,
        row.other_exp || 0,
        row.net_payable || 0,
        row.paid_amount || 0,
        row.bal_amount || 0,
        row.truck_owner || "",
        row.phone_no || "",
        row.pan_no || "",
        row.remark || "",
        row.created_at ? new Date(row.created_at).toLocaleDateString("en-IN") : ""
      ]);
    });

    const ws = XLSX.utils.aoa_to_sheet(wsData);

    ws["!cols"] = headers.map((_, colIndex) => {
      const maxLength = wsData.reduce((max, row) => {
        const cell = row[colIndex];
        const len = cell ? cell.toString().length : 10;
        return Math.max(max, len);
      }, 10);
      return { wch: maxLength + 2 };
    });

    const headerStyle = {
      fill: { fgColor: { rgb: "FFFF00" } },
      font: { bold: true, color: { rgb: "000000" } },
      alignment: { horizontal: "center", vertical: "center" },
      border: {
        top: { style: "thin", color: { rgb: "000000" } },
        bottom: { style: "thin", color: { rgb: "000000" } },
        left: { style: "thin", color: { rgb: "000000" } },
        right: { style: "thin", color: { rgb: "000000" } }
      }
    };

    for (let c = 0; c < headers.length; c++) {
      const cellRef = XLSX.utils.encode_cell({ r: 0, c });
      if (ws[cellRef]) {
        ws[cellRef].s = headerStyle;
      }
    }

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Freight_List");

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array", cellStyles: true });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "Freight_List.xlsx");
  };

  const totals = calculateTotals();

  return (
    <>
      <Grid container spacing={2} mb={2} position={"sticky"} top={10} zIndex={100}>
        <Grid item xs={12} sm={3} style={{ padding: 10 }}>
          <TextField
            label="Search by Branch Name"
            size="small"
            fullWidth
            value={filters.branch}
            onChange={(e) => handleFilterChange("branch", e.target.value)}
            sx={{ minWidth: "40px", padding: 0.2, marginTop: -2, maxHeight: "38px" }}
          />
        </Grid>
        <Grid item xs={12} sm={3} style={{ padding: 10 }}>
          <TextField
            label="Search by Ref No"
            size="small"
            fullWidth
            value={filters.billId}
            onChange={(e) => handleFilterChange("billId", e.target.value)}
            sx={{ minWidth: "40px", padding: 0.2, marginTop: -2, maxHeight: "38px" }}
          />
        </Grid>
        <Grid item xs={12} sm={3} style={{ padding: 10 }}>
          <TextField
            label="Search by Freight ID"
            size="small"
            fullWidth
            value={filters.freightId}
            onChange={(e) => handleFilterChange("freightId", e.target.value)}
            sx={{ minWidth: "40px", padding: 0.2, marginTop: -2, maxHeight: "38px" }}
          />
        </Grid>
        <Grid item xs={12} sm={3} style={{ padding: 10 }}>
          <TextField
            label="Search by Party Name"
            size="small"
            fullWidth
            value={filters.party}
            onChange={(e) => handleFilterChange("party", e.target.value)}
            sx={{ minWidth: "40px", padding: 0.2, marginTop: -2, maxHeight: "38px" }}
          />
        </Grid>
      </Grid>
      <InfiniteScroll
        dataLength={billData.length}
        next={fetchMoreData}
        hasMore={hasMore}
        loader={<h4>Loading...</h4>}
        scrollableTarget="scrollableDiv"
      >
        <TableContainer id="scrollableDiv" sx={{ overflowX: "auto", mt: 2, maxWidth: "100%", height: "70vh" }}>
          <Table
            stickyHeader
            size="small"
            sx={{
              tableLayout: "auto",
              "& td, & th": {
                textAlign: "center",
                whiteSpace: "nowrap",
                padding: "0px 8px",
                fontSize: "0.8125rem",
                borderBottom: "1px solid #ccc",
              },
            }}
          >
            <TableHead
              sx={{
                "& th": {
                  fontWeight: "bold",
                  color: (theme) =>
                    theme.palette.mode === "dark" ? "#2196f3" : "#333",
                  backgroundColor: (theme) =>
                    theme.palette.mode === "dark" ? "black" : "#f5f5f5",
                },
              }}
            >
              <TableRow>
                <TableCell>Settlement</TableCell>
                <TableCell>Sr. No.</TableCell>
                <TableCell>Ref No</TableCell>
                <TableCell>Party Name</TableCell>
                <TableCell>Branch Name</TableCell>
                <TableCell>Freight Id</TableCell>
                <TableCell>Bill Date</TableCell>
                <TableCell>Total Amt</TableCell>
                <TableCell>Hisab Amt</TableCell>
                <TableCell>Rec Amt</TableCell>
                <TableCell>Bal Amt</TableCell>
                <TableCell>Follow Date</TableCell>
                <TableCell>Follow Remark</TableCell>
                <TableCell>Payment Remark</TableCell>
                <TableCell
                  align="center"
                  className="no-print"
                  sx={{
                    position: "sticky",
                    right: 0,
                    backgroundColor: "#fff",
                    zIndex: 3,
                  }}
                >
                  Actions
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredData.length > 0 ? (
                filteredData.map((row, index) => (
                  <TableRow
                    key={index}
                    sx={{
                      backgroundColor: row.is_complete
                        ? "#d0f0c0"
                        : index % 2 === 0
                          ? "#fafafa"
                          : "#ffffff",
                    }}
                  >
                    <TableCell padding="checkbox">
                      <Checkbox
                        size="small"
                        aria-label={`Select row ${index + 1}`}
                        onClick={(e) => {
                          setAnchorEl(e.currentTarget);
                          setSetelement(row.billing_id);
                        }}
                      />
                    </TableCell>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>
                      {row.branch_name === "RAIPUR"
                        ? "SRE"
                        : row.branch_name === "BILASPUR"
                          ? "JHT"
                          : row.branch_name === "ASHUTOSH KUMAR SINGH"
                            ? "AKS"
                            : "MBR"}
                      /{row.billing_id}/{getInitials(row.party_name)}
                    </TableCell>
                    <TableCell>{row.party_name}</TableCell>
                    <TableCell>{row.branch_name}</TableCell>
                    <TableCell>
                      <Tooltip
                        arrow
                        placement="top"
                        title={
                          Array.isArray(row.freights) && row.freights.length > 0 ? (
                            <div
                              style={{
                                maxHeight: "150px",
                                maxWidth: "250px",
                                overflowY: "auto",
                              }}
                            >
                              <table
                                style={{
                                  borderCollapse: "collapse",
                                  fontSize: "12px",
                                  width: "100%",
                                }}
                              >
                                <thead>
                                  <tr>
                                    <th
                                      style={{
                                        padding: "2px 6px",
                                        fontWeight: "bold",
                                        border: "1px solid white",
                                      }}
                                    >
                                      Freight ID
                                    </th>
                                    <th
                                      style={{
                                        padding: "2px 6px",
                                        fontWeight: "bold",
                                        border: "1px solid white",
                                      }}
                                    >
                                      Truck No
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {row.freights.map((freight, i) => (
                                    <tr key={i}>
                                      <td style={{ padding: "2px 6px", border: "1px solid white" }}>
                                        {freight.freight_id}
                                      </td>
                                      <td style={{ padding: "2px 6px", border: "1px solid white" }}>
                                        {freight.truck_no}
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          ) : (
                            row.freight_id
                          )
                        }
                      >
                        <span style={{ cursor: "pointer" }}>
                          {Array.isArray(row.freights) && row.freights.length > 0
                            ? row.freights[0].freight_id
                            : row.freight_id}
                          {Array.isArray(row.freights) && row.freights.length > 1 ? " ..." : ""}
                        </span>
                      </Tooltip>
                    </TableCell>

                    <TableCell>{formatOnlyDate(row.created_at)}</TableCell>
                    <TableCell>{parseFloat(row.total_amount || 0).toFixed(2)}</TableCell>
                    <TableCell>{parseFloat(row.paid_amount || 0).toFixed(2)}</TableCell>
                    <TableCell>{parseFloat(row.hisab_amt || 0).toFixed(2)}</TableCell>
                    <TableCell>
                      {(parseFloat(row.total_amount || 0) - parseFloat(row.hisab_amt || 0)).toFixed(2)}
                    </TableCell>
                    <TableCell>{row.follow_date}</TableCell>
                    <TableCell>{row.remarks}</TableCell>
                    <TableCell>
                      <Tooltip title={row.payment_remarks || ""} arrow placement="top">
                        <span
                          style={{
                            display: "inline-block",
                            maxWidth: "150px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            cursor: "pointer",
                          }}
                        >
                          {row.payment_remarks || "-"}
                        </span>
                      </Tooltip>
                    </TableCell>

                    <TableCell
                      align="center"
                      className="no-print"
                      sx={{
                        position: "sticky",
                        right: 0,
                        backgroundColor: "#fff",
                        zIndex: 1,
                      }}
                    >
                      <IconButton
                        size="small"
                        color="primary"
                        onClick={() => handleEditClick(row)}
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>

                      <IconButton
                        size="small"
                        color="primary"
                        aria-label={`Print invoice ${row.billing_id}`}
                        onClick={() => {
                          switch (row.branch_name.toLowerCase()) {
                            case "raipur":
                              handlePrintClickRaipur(row);
                              break;
                            case "siltara":
                              handlePrintClicksiltara(row);
                              break;
                            case "bilaspur":
                              handlePrintClickBilaspur(row);
                              break;
                            case "ashutosh kumar singh":
                              handlePrintClickAshutosh(row);
                              break;
                            default:
                              console.warn("Unknown branch:", row.branch_name);
                          }
                        }}
                      >
                        <PrintIcon fontSize="small" />
                      </IconButton>
                      <IconButton
                        onClick={(e) => {
                          setAnchorEl1(e.currentTarget);
                          setdeleteRow(row.billing_id);
                        }}
                        color="error"
                        size="small"
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                      <IconButton
                        variant="outlined"
                        onClick={() => handleExportExcel(row.freights)}
                        sx={{ minWidth: "40px", height: "40px", padding: 0 }}
                      >
                        <FileDownloadIcon fontSize="small" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={15} align="center">
                    No records found.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>

            {/* TOTAL ROW - NOW INCLUDING BALANCE AMOUNT */}
            <TableRow
              sx={{
                backgroundColor: "#e3f2fd",
                fontWeight: "bold",
              }}
            >
              <TableCell colSpan={7} align="right">
                Total:
              </TableCell>
              <TableCell align="center">
                {totals.totalAmt}
              </TableCell>
              <TableCell align="center">
                {totals.paidAmt}
              </TableCell>
              <TableCell align="center">
                {totals.hisabAmt}
              </TableCell>
              <TableCell align="center">
                {totals.balAmt}
              </TableCell>
              <TableCell align="center" colSpan={5}></TableCell>
            </TableRow>
          </Table>
        </TableContainer>
      </InfiniteScroll>

      <Dialog
        open={openEditModal}
        onClose={() => setOpenEditModal(false)}
        PaperProps={{
          style: {
            width: "1200px",
            height: "600px",
            maxWidth: "90%",
            overflow: "auto",
          },
        }}
      >
        <DialogContent>
          <Grid
            container
            spacing={2}
            alignItems="center"
            justifyContent="space-between"
            sx={{
              position: "sticky",
              top: -20,
              zIndex: 2,
              backgroundColor: "white",
              py: 1,
              borderBottom: "1px solid #ccc",
            }}
          >
            <Grid item xs={4}>
              <TextField
                label="Total Net Payable"
                value={totalNetPayable.toFixed(2)}
                InputProps={{ readOnly: true }}
                fullWidth
                size="small"
                sx={{ "& .MuiInputBase-root": { height: "35px" } }}
              />
            </Grid>
            <Grid item xs={4} textAlign="right">
              <Button
                variant="contained"
                color="primary"
                onClick={handleSubmit}
                sx={{ height: "35px", marginRight: "10px" }}
              >
                Save
              </Button>

              <Button
                variant="contained"
                color="secondary"
                onClick={() => setOpenEditModal(false)}
                sx={{ height: "35px", marginRight: "10px" }}
              >
                Close
              </Button>
            </Grid>
          </Grid>

          <TableContainer sx={{ overflowX: "auto", maxHeight: "75vh" }}>
            <Table
              stickyHeader
              size="small"
              sx={{
                tableLayout: "auto",
                width: "auto",
                "& td, & th": {
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  padding: "4px 8px",
                  fontSize: "0.8125rem",
                  borderBottom: "1px solid #ccc",
                },
              }}
            >
              <TableHead>
                <TableRow
                  sx={{
                    "& th": {
                      fontWeight: "bold",
                      backgroundColor: "#f5f5f5",
                    },
                  }}
                >
                  <TableCell
                    padding="checkbox"
                    sx={{
                      position: "sticky",
                      left: 0,
                      zIndex: 3,
                    }}
                  ></TableCell>
                  <TableCell>SR. No</TableCell>
                  <TableCell>Freight Id</TableCell>
                  <TableCell>Party Name</TableCell>
                  <TableCell>Branch Name</TableCell>
                  <TableCell>Loading Date</TableCell>
                  <TableCell>Unloading Date</TableCell>
                  <TableCell>Truck No.</TableCell>
                  <TableCell>D.O. No.</TableCell>
                  <TableCell>T.P. No.</TableCell>
                  <TableCell>From</TableCell>
                  <TableCell>To</TableCell>
                  <TableCell>Loading Wt</TableCell>
                  <TableCell>Receiving Wt</TableCell>
                  <TableCell>Shortage Wt</TableCell>
                  <TableCell>Billing Wt</TableCell>
                  <TableCell>Freight Rate</TableCell>
                  <TableCell>Freight Amt</TableCell>
                  <TableCell>TDS %</TableCell>
                  <TableCell>TDS Amt</TableCell>
                  <TableCell>Shortage Rate</TableCell>
                  <TableCell>Shortage Amt</TableCell>
                  <TableCell>Ad Mines</TableCell>
                  <TableCell>Ad Diesel</TableCell>
                  <TableCell>Ad Cash</TableCell>
                  <TableCell>Total Ad</TableCell>
                  <TableCell>Commission</TableCell>
                  <TableCell>Net Amt</TableCell>
                  <TableCell>Others Exp.</TableCell>
                  <TableCell>Net Payable</TableCell>
                  <TableCell>Truck Owner</TableCell>
                  <TableCell>Phone No.</TableCell>
                  <TableCell>PAN No.</TableCell>
                  <TableCell>Remark</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {freightOptions.map((row, index) => (
                  <TableRow
                    key={row.freight_id}
                    sx={{
                      backgroundColor: index % 2 === 0 ? "#fafafa" : "#fff",
                    }}
                  >
                    <TableCell
                      padding="checkbox"
                      sx={{
                        position: "sticky",
                        left: 0,
                        backgroundColor: "#f5f5f5",
                      }}
                    >

                      <Checkbox
                        checked={row.is_bill}
                        onChange={() => handleIsBillToggle(row.freight_id)}
                        size="small"
                      />
                    </TableCell>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{row.freight_id}</TableCell>
                    <TableCell>{row.party_name}</TableCell>
                    <TableCell>{row.branch_name}</TableCell>
                    <TableCell>{row.loading_date}</TableCell>
                    <TableCell>{row.unloading_date}</TableCell>
                    <TableCell>{row.truck_no}</TableCell>
                    <TableCell>{row.do_no}</TableCell>
                    <TableCell>{row.tp_no}</TableCell>
                    <TableCell>{row.from_location}</TableCell>
                    <TableCell>{row.to_location}</TableCell>
                    <TableCell>{row.loading_wt}</TableCell>
                    <TableCell>{row.received_wt}</TableCell>
                    <TableCell>{row.shortage_wt}</TableCell>
                    <TableCell>{row.billing_wt}</TableCell>
                    <TableCell>{row.freight_rate}</TableCell>
                    <TableCell>{row.freight_amt}</TableCell>
                    <TableCell>{row.tds_per}</TableCell>
                    <TableCell>{row.tds_amt}</TableCell>
                    <TableCell>{row.shortage_rate}</TableCell>
                    <TableCell>{row.shortage_amt}</TableCell>
                    <TableCell>{row.ad_mines_exp}</TableCell>
                    <TableCell>{row.ad_diesel_exp}</TableCell>
                    <TableCell>{row.ad_cash_exp}</TableCell>
                    <TableCell>{row.total_advance}</TableCell>
                    <TableCell>{row.commission}</TableCell>
                    <TableCell>{row.net_amount}</TableCell>
                    <TableCell>{row.other_exp}</TableCell>
                    <TableCell>{row.net_payable}</TableCell>
                    <TableCell>{row.truck_owner}</TableCell>
                    <TableCell>{row.phone_no}</TableCell>
                    <TableCell>{row.pan_no}</TableCell>
                    <TableCell>{row.remark}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
      </Dialog>

      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => {
          setAnchorEl(null);
          setSetelement(null);
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <Box sx={{ p: 1 }}>
          <Typography variant="body2">Are you sure?</Typography>
          <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
            <Button
              color="error"
              size="small"
              onClick={async () => {
                try {
                  await handleComplete(settelement);
                } finally {
                  setAnchorEl(null);
                  setSetelement(null);
                }
              }}
            >
              Yes
            </Button>
            <Button
              size="small"
              onClick={() => {
                setAnchorEl(null);
                setSetelement(null);
              }}
            >
              No
            </Button>
          </Box>
        </Box>
      </Popover>

      <Popover
        open={Boolean(anchorEl1)}
        anchorEl={anchorEl1}
        onClose={() => {
          setAnchorEl1(null);
          setdeleteRow(null);
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <Box sx={{ p: 1 }}>
          <Typography variant="body2">Are you sure to delete?</Typography>
          <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
            <Button
              color="error"
              size="small"
              onClick={async () => {
                try {
                  await handleDelete(deleteRow);
                } finally {
                  setAnchorEl1(null);
                  setdeleteRow(null);
                }
              }}
            >
              Yes
            </Button>
            <Button
              size="small"
              onClick={() => {
                setAnchorEl1(null);
                setdeleteRow(null);
              }}
            >
              No
            </Button>
          </Box>
        </Box>
      </Popover>
    </>
  );
};

export default BillSummaryTable;